import { FC } from "react";
import { GBtn } from "..";
import { css } from "@emotion/react";

type Props = React.ComponentProps<typeof GBtn> & {
  waveColor?: string;
};

/**
 & .wave {
      width: 200px;
      height: 200px;
      background-color: ${waveColor};
      box-shadow: inset 0 0 50px rgba(0, 0, 0, 0.5);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -90px;
      transition: 0.4s;

      &::before,
      &::after {
        width: 200%;
        height: 200%;
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -75%);
      }

      &::before {
        border-radius: 45%;
        background-color: rgba(20, 20, 20, 1);
        animation: wave 5s linear infinite;
      } 
 */

const GBtnLiq: FC<Props> = ({ waveColor, ...rest }) => {
  const styles = css`
    position: relative;
    overflow: hidden;

    & span {
      position: relative;
      z-index: 1;
      color: inherit;
    }

    &:hover {
      .wave {
        top: -120px;
      }
    }

    & .wave {
      width: 100%;
      height: 310%;
      background-color: ${waveColor};
      box-shadow: inset 0 0 50px rgba(0, 0, 0, 0.5);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -90px;
      transition: 0.4s;

      &::before,
      &::after {
        width: 200%;
        height: 200%;
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -75%);
      }

      &::before {
        border-radius: 45%;
        background-color: rgba(20, 20, 20, 1);
        animation: wave 5s linear infinite;
      }

      &::after {
        border-radius: 40%;
        background-color: rgba(20, 20, 20, 0.5);
        animation: wave 10s linear infinite;
      }
    }

    @keyframes wave {
      0% {
        transform: translate(-50%, -75%) rotate(0deg);
      }

      100% {
        transform: translate(-50%, -75%) rotate(360deg);
      }
    }
  `;

  return (
    <GBtn css={styles} {...rest} hasChild>
      <span>{rest.text}</span>
      <div className="wave"></div>
    </GBtn>
  );
};

GBtnLiq.defaultProps = {
  waveColor: "#444857",
  fontColor: "#fff",
};

export default GBtnLiq;

/*

addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    fontColor: {
        title: "Font Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#21242C",
    },
    waveColor: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#444857",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "Home",
    },
    ripple: {
        title: "Ripple",
        type: ControlType.Boolean,
        description: "Adds a ripple effect on click if true",
        defaultValue: true,
    },
    radius: {
        title: "Radius",
        type: ControlType.Number,
        defaultValue: 8,
    },
})
*/
